<template lang="html">

  <div class="proyectos">

    <section class="vh intro">
      <div class="bkg-pieza waypoints-instant -responsiveIntro" data="fadeInUp">
        <a href="#" v-scroll-to="'.cat-1'" class="scrolldown"></a>
        <div class="col-50 flex column nowrap justify-center align-center animated fadeInLeft -introText">
          <div class="container-text">
            <h2 class="title title-52" v-html="$t('proyectos_IDI.titulo')"></h2>
            <p v-html="$t('proyectos_IDI.entradilla')"></p>
          </div>
        </div>
      </div>
    </section>

    <section class="proyecto-cat flex wrap justify-end align-stretch">
      <div class="cat-2 desc-cat flex column justify-center">
        <h2 v-html="$t('proyectos_IDI.cogeneracion.title')" class="title title-36"></h2>
        <p v-html="$t('proyectos_IDI.cogeneracion.description')"></p>

      </div>
      <div class="cat-2 img-cat" data-value="bkg-cat2"></div>
    </section>
    <section class="proyecto-cat flex wrap justify-end align-stretch">
      <div class="cat-4 img-cat flex wrap justify-end align-stretch" data-value="bkg-cat4"></div>
      <div class="cat-4 desc-cat flex column justify-center">
        <h2 class="title title-36" v-html="$t('proyectos_IDI.pila_combustible.title')"></h2>
        <p v-html="$t('proyectos_IDI.pila_combustible.description')"></p>
      </div>
    </section>

    <section class="proyectos-cat-bkg">
      <section class="proyecto-cat flex wrap justify-end align-stretch">
        <div class="cat-3 desc-cat flex column justify-center with-button w-35">
          <h2 class="title title-36" v-html="$t('proyectos_IDI.aeronautica.title')"></h2>
          <p v-html="$t('proyectos_IDI.aeronautica.description1')"></p>
        </div>
        <div class="cat-3 img-cat" data-value="bkg-cat9"></div>
      </section>
      <section class="proyecto-cat flex wrap justify-start align-stretch">
        <div class="cat-3 img-cat" data-value="bkg-cat10"></div>
        <div class="cat-3 desc-cat mn-h w-55 flex column justify-center with-button">
          <p v-html="$t('proyectos_IDI.aeronautica.description2')"></p>
        </div>
      </section>
      <section class="proyecto-cat flex wrap justify-end align-stretch">
        <div class="cat-3 desc-cat flex column justify-center with-button mn-h w-55">
          <p v-html="$t('proyectos_IDI.aeronautica.description3')"></p>
          <p v-html="$t('proyectos_IDI.aeronautica.description4')"></p>
        </div>
        <div class="cat-3 img-cat" data-value="bkg-cat11"></div>
      </section>
      <div class="flex wrap justify-center logos-sellos">
        <img src="/static/img/proyectos/logo-ajusath1.jpg">
        <img class="half" src="/static/img/proyectos/logo-ajusath2.jpg">
        <img src="/static/img/proyectos/logo-ajusath4.png">
      </div>
    </section>
    <section class="proyecto-texto" :hide="!proyecto_6">
      <div class="container">
        <p v-html="$t('proyectos_IDI.cogeneracion.desplegable.texto_1')"></p>
        <p v-html="$t('proyectos_IDI.cogeneracion.desplegable.texto_2')"></p>
      </div>
    </section>
    <section class="product-box -componentes row-center">
      <h2 class="title title-36" v-html="$t('proyectos_IDI.otros_proyectos.title')"></h2>
      <div class="despl-otros-product waypoints" data="fadeInUp">
        <div class="item" data-product="don-qhyxote-home" @click="openInfo('don_qhyxote_home')">
          <div class="mask"></div>
          <span class="title title-36" v-html="$t('proyectos_IDI.qhyxote_home.title')"></span>
        </div>
        <div class="item" data-product="don-qhyxote-car" @click="openInfo">
          <div class="mask"></div>
          <span class="title title-36" v-html="$t('proyectos_IDI.qhyxote_car.title')"></span>
        </div>
        <div class="item" data-product="don-qhyxote-scooter" @click="openInfo">
          <div class="mask"></div>
          <span class="title title-36" v-html="$t('proyectos_IDI.qhyxote_scooter.title')"></span>
        </div>
      </div>
      <section class="proyecto-cat flex wrap justify-end align-stretch " data-product="don-qhyxote-home">
        <div class="cat-5 img-cat flex wrap justify-end align-stretch" data-value="bkg-don-qhyxote-home"></div>
        <div class="cat-5 desc-cat flex column justify-center">
          <h2 class="title title-36" v-html="$t('proyectos_IDI.qhyxote_home.title')"></h2>
          <p v-html="$t('proyectos_IDI.qhyxote_home.description')"></p>
        </div>
      </section>
      <section class="proyecto-cat flex wrap justify-end align-stretch " data-product="don-qhyxote-car">
        <div class="cat-5 img-cat flex wrap justify-end align-stretch" data-value="bkg-don-qhyxote-car"></div>
        <div class="cat-5 desc-cat flex column justify-center">
          <h2 class="title title-36" v-html="$t('proyectos_IDI.qhyxote_car.title')"></h2>
          <p v-html="$t('proyectos_IDI.qhyxote_car.description')"></p>
        </div>
      </section>
      <section class="proyecto-cat flex wrap justify-end align-stretch " data-product="don-qhyxote-scooter">
        <div class="cat-5 img-cat flex wrap justify-end align-stretch" data-value="bkg-don-qhyxote-scooter"></div>
        <div class="cat-5 desc-cat flex column justify-center">
          <h2 class="title title-36" v-html="$t('proyectos_IDI.qhyxote_scooter.title')"></h2>
          <p v-html="$t('proyectos_IDI.qhyxote_scooter.description')"></p>
        </div>
      </section>
    </section>


    <otras-secciones :data="['productos', 'tecnologia']"></otras-secciones>

  </div>

</template>

<script lang="js">

import Otras_Secciones from '@/components/parts/acceso-a-secciones';

export default {
  name: 'proyectos',
  props: [],
  mounted() {
    if ($(window).width() < 750) {
      this.setTabsProducts()
    }
  },
  data() {
    return {
      proyecto_3: false,
      proyecto_6: false,

    }
  },
  methods: {
    openInfo: function () {
      $('.item').removeClass('active')
      $('.proyecto-cat').removeClass('active')
      event.target.parentNode.classList.toggle("active");
      document.querySelector(".proyecto-cat[data-product='" + event.target.parentNode.getAttribute("data-product") + "']").classList.toggle('active')
      // if ($(window).width() < 750) {
      //   event.target.parentNode.insertAdjacentHTML('afterend', document.querySelector(".proyecto-cat[data-product='"+event.target.parentNode.getAttribute("data-product")+"']").innerHTML)
      // }

    },
    setTabsProducts: function () {
      $('.item').each(function () {
        console.log($(this).attr('data-product'))
        let dataProduct = $(this).attr('data-product')
        $(this).after("<div class='proyecto-cat flex wrap justify-end align-stretch -responsive' data-product='" + dataProduct + "'>" + $('.proyecto-cat[data-product="' + dataProduct + '"]').html() + "</div>")
      });
    }


  },
  components: {
    'otras-secciones': Otras_Secciones
  }
}
</script>

<style scoped>
.proyecto-cat .desc-cat {
  position: relative;
}

.show-section {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 100px;
  font-size: 40px;
  font-weight: 300;
  color: #fff;
  background: transparent url(/static/img/more-gray.svg) center/auto 40px no-repeat;
  border: none;
  width: 100%;
  outline: none;
  cursor: pointer;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  background-position-x: 90%;
}

.show-section[show="true"] {
  background: transparent url(/static/img/less-gray.svg) 90% / auto 40px no-repeat;
}

.proyecto-texto {
  padding: 50px;
  background: url(/static/img/bkg-metal.jpg) center/cover no-repeat;
  -webkit-transition: height 0.3s linear, padding-top 0.3s linear,
    padding-bottom 0.3s linear, border-top-width 0.3s linear,
    border-top-width 0.3s linear;
  transition: height 0.3s linear, padding-top 0.3s linear,
    padding-bottom 0.3s linear, border-top-width 0.3s linear,
    border-top-width 0.3s linear;
}

.proyecto-texto[hide="true"] {
  overflow: hidden;
  padding-top: 0;
  padding-bottom: 0;
  height: 0;
  border-width: 0 1px;
}

.proyecto-texto p {
  color: #646464;
  line-height: 25px;
  font-size: 16px;
  /* // font-family: 'HalisGR-Book'; */
}

.product-box {
  padding: 80px 50px;
  position: relative;
}

.despl-otros-product {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
}

.despl-otros-product .item {
  width: calc(100% / 3);
  height: 310px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 2;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  cursor: pointer;
  overflow: hidden;
}

.despl-otros-product .item[data-product="don-qhyxote-home"],
[data-value="bkg-don-qhyxote-home"] {
  background-image: url(/static/img/proyectos/qhyxote-home.jpg);
}

.despl-otros-product .item[data-product="don-qhyxote-car"],
[data-value="bkg-don-qhyxote-car"] {
  background-image: url(/static/img/proyectos/qhyxote-car.jpg);
}

.despl-otros-product .item[data-product="don-qhyxote-scooter"],
[data-value="bkg-don-qhyxote-scooter"] {
  background-image: url(/static/img/proyectos/qhyxote-scooter.jpg);
}

.despl-otros-product .item .mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: #ffffffa1;
}

.despl-otros-product .item .mask::before {
  content: "";
  width: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  background: #02203c;
  color: white;
  height: 100px;
  background-image: url(/static/img/more.svg);
  background-position: center;
  align-items: center;
  background-repeat: no-repeat;
  transform: translateY(100%);
  transition: all 2s cubic-bezier(0, 1, 0.5, 1);
}

.despl-otros-product .item:hover .mask::before {
  transform: translateY(0);
  transition: all 2s cubic-bezier(0, 1, 0.5, 1);
}

.despl-otros-product .item.active .mask::before {
  content: "";
  width: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  background: #02203c;
  color: white;
  height: 100px;
  background-image: url(/static/img/less.svg);
  background-position: center;
  align-items: center;
  background-repeat: no-repeat;
  transform: translateY(0);
}

.despl-otros-product .item span {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  text-align: center;
  font-weight: 600;
}

.product-box .proyecto-cat {
  height: 0;
  min-height: 0;
}

.product-box .proyecto-cat.active {
  display: flex;
  width: 100%;
  flex-direction: row-reverse;
  height: auto;
  min-height: 500px;
}

.product-box .proyecto-cat .img-cat {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}

.logos-sellos img {
  object-fit: contain;
  max-width: 20%;
}

.logos-sellos .half {
  margin: 0 60px;
}

@media screen and (max-width: 1200px) {
  .proyecto-cat .img-cat {
    width: 50% !important;
  }

  .proyecto-cat .desc-cat {
    width: 50% !important;
  }

}

@media screen and (max-width: 1010px) {
  .despl-otros-product .item span {
    font-size: 25px;
    line-height: 1.2em;
  }
}

@media screen and (max-width: 900px) {

  .proyectos-cat-bkg .proyecto-cat { 
    padding-bottom: 0px !important;
  }

  .despl-otros-product .item:hover .mask::before,
  .despl-otros-product .item .mask::before,
  .despl-otros-product .item .mask:before {
    transform: translateY(0);
  }

  .proyecto-cat {
    min-height: 0;
  }

  .proyecto-cat .img-cat {
    width: 100% !important;
    min-height: 33.33333vh;
    order: -1;
  }

  .proyecto-cat .desc-cat {
    width: 100% !important;
    min-height: 0;
  }

  [data-value="bkg-cat4"] {
    background-position: center center;
  }

  .proyecto-cat .desc-cat.with-button {
    padding-bottom: 60px;
  }

  .proyecto-texto {
    padding: 20px 0;
  }

  .proyecto-cat .title {
    margin-bottom: 15px;
  }
}

@media screen and (max-width: 750px) {

  .despl-otros-product .item {
    width: 100%;
    height: 300px;
  }

  .despl-otros-product .item .mask::before,
  .despl-otros-product .item.active .mask::before,
  .despl-otros-product .item:hover .mask::before,
  .despl-otros-product .item.active:hover .mask::before {
    background-size: 52px !important;
    width: 100%;
    background-position: center center;
    height: 70px;
    transform: translateY(0);
    transition: none;
  }

  .product-box {
    padding: 40px 0;
  }

  .proyectos-cat-bkg {
    padding-bottom: 0;
  }

  .logos-sellos img {
    max-width: 24%;
  }
  .logos-sellos .half {
    margin: 0 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/views/proyectos.vue